(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-bf-shared"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select',function(event){var target=event.target;if(!(target instanceof Element)||!target.closest('.sa-early-bird'))return;var details=target.matches('details')?target:target.closest('details');if(details)details.open=true;});
document.addEventListener('click',function(event){var link=event.target.closest&&event.target.closest('.sa-early-bird a[href^="#"]');if(!link)return;var id=link.getAttribute('href').slice(1);if(!id)return;var target=document.getElementById(id);if(!target)return;event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});var field=target.querySelector('input[type="email"]');if(field)field.focus({preventScroll:true});});
  } catch(e) { console.error(e); }
})();

})();
